export default __webpack_public_path__ + "static/media/me.401da0c0.svg";